/* eslint-disable react/no-multi-comp */
import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { HomepageThemeButtonDisplay } from "./homepage-theme-button-display";
import { Container, theme } from "./styles";
export { HomepageThemeButtonDisplay } from "./homepage-theme-button-display";
export { config as homepageThemeConfig } from "./config";
export const HomepageTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "homepage-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
export const HomepageThemeSignUpButtonDisplay = () => /*#__PURE__*/React.createElement(HomepageThemeButtonDisplay, {
  "data-qa": "homepage-theme-sign-up-button-display"
}, "Get Our Newsletter");
export const HomepageThemeFindOurMoreDisplay = () => /*#__PURE__*/React.createElement(HomepageThemeButtonDisplay, {
  "data-qa": "homepage-theme-find-our-more-display"
}, "Find Out More");
HomepageTheme.displayName = "HomepageTheme";